<template>
  <v-container v-if="userProfile" grid-list-xs>
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card v-if="dialog" style="background-color:#F4F7FA;">
        <v-toolbar flat dark color="accent">
          <v-layout row wrap>
            <v-flex lg4 md4 xs4>
              <v-layout ml-3 align-center>
                <v-spacer></v-spacer>
              </v-layout>
            </v-flex>
            <v-flex lg4 md4 xs4 class="text-xs-center" align-center>Perfil de Usuario</v-flex>
            <v-flex lg4 md4 xs4>
              <v-layout class="margin-all2" align-end></v-layout>
            </v-flex>
          </v-layout>
          <v-toolbar-items>
            <v-btn icon dark @click="existNewChanges?confirm=true:close()">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <vue-perfect-scrollbar
          class="inbox-content-scroll"
          style="height:calc(100vh - 70px)"
          id="v-step-4"
        >
          <v-container grid-list-xs>
            <v-card>
              <v-container grid-list-xs>
                <v-layout row wrap>
                  <v-flex lg12 md12 xs12 sm12>
                    <v-card flat>
                      <span style="color:#002f87">Información Personal</span>
                      <v-divider></v-divider>
                      <v-layout pt-0 mt-0 row wrap align-content-start>
                        <v-flex lg12 class="text-lg-left text-xs-left">
                          <v-layout pt-0 mt-0 row wrap align-content-start>
                            <v-flex lg12 class="text-lg-left text-xs-left">
                              <div style="padding-top:15px">
                                <input
                                  class="inputfile"
                                  type="file"
                                  id="profilePhoto"
                                  ref="profilePhoto"
                                  accept="image/*"
                                  style="display:none"
                                  v-on:change="handleFileUpload($refs.profilePhoto)"
                                  :disabled="disableInformation"
                                >
                                <v-avatar
                                  v-if="disableInformation"
                                  size="70"
                                  color="grey lighten-4"
                                >
                                  <v-img v-bind:src="userProfile.photoUrl"/>
                                </v-avatar>
                                <v-avatar v-else size="70" color="white">
                                  <v-img v-bind:src="userProfile.photoUrl" alt="Profile Photo"/>
                                  <div style="position:absolute">
                                    <v-btn large icon @click="$refs.profilePhoto.click()">
                                      <v-icon large color="white">photo_camera</v-icon>
                                    </v-btn>
                                  </div>
                                </v-avatar>
                              </div>
                              <!--                               <div style="position:absolute;right:-1%">
                                <v-btn @click="enableEdit()" icon>
                                  <v-icon color="accent">edit</v-icon>
                                </v-btn>
                              </div>-->
                            </v-flex>
                            <!--                         <v-flex pa-0 ma-0 lg1 xs1 class="text-lg-right text-xs-right">
                          <div style="position:absolute;right:-1%">
                            <v-btn @click="enableEdit()" icon>
                              <v-icon color="accent">edit</v-icon>
                            </v-btn>
                          </div>
                            </v-flex>-->
                          </v-layout>
                          <!--                          <div style="position:absolute;right:-1%">
                            <v-btn @click="enableEdit()" icon>
                              <v-icon color="accent">edit</v-icon>
                            </v-btn>
                          </div>-->
                        </v-flex>
                        <!--                         <v-flex pa-0 ma-0 lg1 xs1 class="text-lg-right text-xs-right">
                          <div style="position:absolute;right:-1%">
                            <v-btn @click="enableEdit()" icon>
                              <v-icon color="accent">edit</v-icon>
                            </v-btn>
                          </div>
                        </v-flex>-->
                      </v-layout>
                      <br>
                      <!-- :disabled="disableInformation" -->
                      <v-text-field
                        v-if="!checkAdmin()"
                        v-model="userProfile.user_id"
                        :counter="13"
                        :maxlength="13"
                        label="Id de Usuario"
                        mask="#############"
                        required
                        readonly
                        :disabled="disableInformation"
                      ></v-text-field>
                      <v-text-field
                        v-model="userProfile.identity"
                        :counter="13"
                        :maxlength="13"
                        label="Identificación"
                        mask="#############"
                        data-vv-name="Identificación"
                        required
                        readonly
                        :disabled="disableInformation"
                      ></v-text-field>
                      <!-- :disabled="disableInformation" -->
                      <v-text-field
                        v-model="userProfile.business_name"
                        v-if="userProfile.person_type=='JURIDICO'"
                        :counter="50"
                        label="Razón Social"
                        required
                        :maxlength="50"
                        :disabled="disableInformation"
                        readonly
                      ></v-text-field>
                      <v-text-field
                        v-if="userProfile.person_type=='JURIDICO'"
                        v-model="userProfile.trademark"
                        :counter="50"
                        label="Nombre Comercial"
                        required
                        :maxlength="50"
                        :disabled="disableInformation"
                        readonly
                      ></v-text-field>
                      <v-text-field
                        v-if="userProfile.person_type=='JURIDICO'"
                        v-model="userProfile.legal_representative"
                        :counter="50"
                        label="Representante Legal"
                        required
                        :maxlength="50"
                        :disabled="disableInformation"
                        readonly
                      ></v-text-field>
                      <v-text-field
                        v-if="userProfile.person_type=='NATURAL'||checkAdmin()"
                        v-model="userProfile.first_name"
                        :counter="50"
                        label="Primer Nombre"
                        data-vv-name="Primer Nombre"
                        required
                        :maxlength="50"
                        :disabled="disableInformation"
                        readonly
                      ></v-text-field>
                      <v-text-field
                        v-if="userProfile.person_type=='NATURAL'||checkAdmin()"
                        v-model="userProfile.second_name"
                        :counter="50"
                        label="Segundo Nombre"
                        data-vv-name="Segundo Nombre"
                        required
                        :maxlength="50"
                        :disabled="disableInformation"
                        readonly
                      ></v-text-field>
                      <v-text-field
                        v-if="userProfile.person_type=='NATURAL'||checkAdmin()"
                        v-model="userProfile.first_surname"
                        :counter="50"
                        label="Primer Apellido"
                        data-vv-name="Primer Apellido"
                        required
                        :maxlength="50"
                        :disabled="disableInformation"
                        readonly
                      ></v-text-field>
                      <v-text-field
                        v-if="userProfile.person_type=='NATURAL'||checkAdmin()"
                        v-model="userProfile.second_surname"
                        :counter="50"
                        label="Segundo Apellido"
                        data-vv-name="Segundo Apellido"
                        required
                        :maxlength="50"
                        readonly
                        :disabled="disableInformation"
                      ></v-text-field>

                      <v-text-field
                        v-if="!checkAdmin()&&checkAPS()"
                        v-model="userProfile.creation_date"
                        label="Fecha de Constitución"
                        append-icon="event"
                        readonly
                        :disabled="disableInformation"
                      ></v-text-field>
                      <v-menu
                        ref="menu"
                        v-if="!checkAdmin()"
                        :close-on-content-click="false"
                        v-model="menu"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                      >
                        <v-text-field
                          label="Fecha de Nacimiento"
                          readonly
                          v-if="!checkAdmin()"
                          slot="activator"
                          v-model="userProfile.birth_date"
                          append-icon="event"
                          :disabled="disableInformation"
                        ></v-text-field>
                        <v-date-picker
                          ref="picker"
                          v-model="userProfile.birth_date"
                          min="1950-01-01"
                          @change="saveDate"
                          locale="es-419"
                        ></v-date-picker>
                      </v-menu>

                      <v-autocomplete
                        v-if="!checkAdmin()"
                        :items="catalogsNacionalities"
                        :filter="customFilter"
                        :disabled="disableInformation"
                        item-text="value"
                        item-value="value"
                        label="Nacionalidad"
                        v-model="userProfile.nationality"
                      ></v-autocomplete>
                      <!--                       <v-text-field
                        v-model="profile.nationality"
                        label="Nacionalidad"
                        :disabled="disableInformation"
                      ></v-text-field>-->
                      <!--                       <v-text-field
                        v-model="profile.gender"
                        label="Género"
                        :disabled="disableInformation">
                      </v-text-field>-->
                      <!--               {{catalogsGender}} -->
                      <label
                        v-if="!checkAdmin()"
                        aria-hidden="true"
                        class="v-label v-label--active theme--light"
                        style="left: 0px; right: auto; position: absolute; font-size:12px"
                      >Género</label>
                      <v-layout v-if="!checkAdmin()" row wrap>
                        <v-checkbox
                          :disabled="disableInformation"
                          @change="changeGender('Masculino')"
                          v-model="gender.Masculino"
                          label="Masculino"
                        ></v-checkbox>
                        <v-checkbox
                          :disabled="disableInformation"
                          @change="changeGender('Femenino')"
                          v-model="gender.Femenino"
                          label="Femenino"
                        ></v-checkbox>
                        <v-checkbox
                          :disabled="disableInformation"
                          @change="changeGender('undefined')"
                          v-model="gender.undefined"
                          label="No Aplica"
                        ></v-checkbox>
                      </v-layout>
                      <v-select
                        v-if="!checkAdmin()"
                        :disabled="disableInformation"
                        :items="catalogsCivilStatus"
                        v-model="userProfile.civil_status"
                        item-text="value"
                        item-value="code"
                        label="Estado Civil"
                      ></v-select>
                      <v-text-field
                        v-if="!checkAdmin()"
                        v-model="userProfile.country"
                        label="País"
                        :disabled="disableInformation"
                      ></v-text-field>
                      <v-select
                        v-if="!checkAdmin()"
                        :disabled="disableInformation"
                        :items="catalogsProvince"
                        v-model="userProfile.province"
                        item-text="value"
                        item-value="value"
                        label="Provincia"
                        @change="changeProvince"
                      ></v-select>
                      <!--                       <v-text-field
                        v-model="profile.province"
                        label="Provincia"
                        :disabled="disableInformation">
                      </v-text-field>-->
                      <!--                       <v-text-field
                        v-model="profile.canton"
                        label="canton"
                        :disabled="disableInformation">
                      </v-text-field>-->
                      <v-select
                        v-if="!checkAdmin()"
                        :disabled="disableInformation"
                        :items="catalogsCanton"
                        v-model="userProfile.canton"
                        item-text="code"
                        item-value="provinceCode"
                        label="Cantón"
                      ></v-select>
                      <!-- {{catalogsCity}} -->
                      <v-select
                        v-if="!checkAdmin()"
                        :disabled="disableInformation"
                        :items="catalogsCity"
                        v-model="userProfile.city"
                        item-text="value"
                        item-value="value"
                        label="Ciudad"
                      ></v-select>
                      <!--                       <v-text-field
                        v-model="profile.city"
                        label="Ciudad"
                        :disabled="disableInformation">
                      </v-text-field>-->
                      <!-- {{catalogsProvince}} -->
                      <!-- {{catalogsCanton}} -->
                      <v-text-field
                        v-if="!checkAdmin()"
                        v-model="userProfile.parish"
                        label="Parroquia"
                        :disabled="disableInformation"
                      ></v-text-field>
                      <v-text-field
                        v-if="!checkAdmin()"
                        v-model="userProfile.home_address"
                        label="Dirección Domiciliaria"
                        :disabled="disableInformation"
                      ></v-text-field>
                      <v-text-field
                        v-if="checkAPS()&&!checkAdmin()"
                        v-model="userProfile.office_address"
                        label="Dirección Oficina"
                        :disabled="disableInformation"
                      ></v-text-field>
                      <v-text-field
                        readonly
                        v-model="userProfile.email"
                        label="Email"
                        data-vv-name="Email"
                        :disabled="disableInformation"
                      ></v-text-field>
                      <v-text-field
                        v-if="!checkAdmin()"
                        v-model="userProfile.notification_email"
                        label="Email Notificaciones"
                        :disabled="disableInformation"
                      ></v-text-field>
                      <v-text-field
                        v-if="!checkAdmin()"
                        v-model="userProfile.billing_email"
                        label="Email Facturación"
                        :disabled="disableInformation"
                      ></v-text-field>
                      <v-text-field
                        v-if="!checkAdmin()"
                        v-model="userProfile.office_email"
                        label="Email Oficina"
                        :disabled="disableInformation"
                      ></v-text-field>
                      <v-text-field
                        v-if="!checkAdmin()"
                        v-model="userProfile.personal_email"
                        label="Email Personal"
                        :disabled="disableInformation"
                      ></v-text-field>
                      <v-text-field
                        v-if="!checkAdmin()"
                        v-model="userProfile.cell_phone"
                        label="Teléfono Celular"
                        mask="##########"
                        :disabled="disableInformation"
                      ></v-text-field>
                      <v-text-field
                        v-if="!checkAdmin()&&checkAPS()"
                        v-model="userProfile.office_phone"
                        label="Teléfono Oficina"
                        mask="##########"
                        :disabled="disableInformation"
                      ></v-text-field>
                      <v-text-field
                        v-if="!checkAdmin()&&!checkAPS()"
                        v-model="userProfile.home_phone"
                        label="Teléfono Domicilio"
                        mask="##########"
                        :disabled="disableInformation"
                      ></v-text-field>

                      <v-text-field
                        v-if="!checkAdmin()"
                        v-model="userProfile.web_page"
                        label="Pagina Web"
                        :disabled="disableInformation"
                      ></v-text-field>
                      <v-text-field
                        v-if="!checkAdmin()"
                        v-model="userProfile.postal_code"
                        label="Código Postal"
                        :disabled="disableInformation"
                      ></v-text-field>

                      <v-text-field
                        v-if="checkAPS()"
                        v-model="userProfile.accreditation_date"
                        label="Fecha de Acreditación"
                        append-icon="event"
                        readonly
                        :disabled="disableInformation"
                      ></v-text-field>
                      <!--                       <v-text-field
                        v-model="profile.id_aps_vt"
                        label="Id Visual Time"
                        :disabled="disableInformation"
                      ></v-text-field>-->
                      <v-text-field
                        readonly
                        v-if="!checkAdmin()&&checkAPS()"
                        v-model="userProfile.institute_code"
                        label="Código de Institución"
                        :disabled="disableInformation"
                      ></v-text-field>
                      <label v-if="!checkAdmin()&&checkAPS()" for>Agencias:</label>
                      <v-chip
                        v-if="!checkAdmin()&&checkAPS()"
                        color="accent"
                        small
                        v-for="(agency,i) in userProfile.agencies"
                        :key="i"
                      >
                        <span style="color:white">{{agency.name}} ({{agency.id_aps_sos}})</span>
                      </v-chip>
                      <br>
                      <label v-if="checkAPS()&&!checkAdmin()">Ejecutivos:</label>
                      <v-chip color="accent" small v-for="(executiveCode,j) in userProfile.executives">
                        <span style="color:white">{{executiveCode}}</span>
                      </v-chip>
                    </v-card>
                    <br>
                    <v-switch
                      v-if="!disableInformation"
                      v-model="userProfile.notification"
                      label="Recibir Notificaciones"
                      @change="updateAccounts()"
                    ></v-switch>
                    <v-card flat v-if="!disableInformation">
                      <span style="color:#002f87">Seguridad</span>
                      <v-divider></v-divider>
                      <div transition="fade-transition" v-if="!disableInformation">
                        <v-form ref="formChangePass" v-model="isValidNewPassword">
                          <v-text-field
                            v-model="changePass.oldPassword"
                            :append-icon="password1 ? 'visibility_off' : 'visibility'"
                            :type="password1 ? 'text' : 'password'"
                            name="input-10-1"
                            label="Contraseña Actual"
                            @click:append="password1 = !password1"
                            :error="oldPassError"
                            :error-messages="oldPassErrorText"
                            :rules="[rules.required]"
                          ></v-text-field>
                          <v-text-field
                            v-model="passValidate"
                            :append-icon="password2 ? 'visibility_off' : 'visibility'"
                            :type="password2 ? 'text' : 'password'"
                            name="input-10-1"
                            label="Nueva contraseña"
                            @click:append="password2 = !password2"
                            :error="validatePassError"
                            :error-messages="validatePassErrorText"
                            :rules="[rules.required,rules.validPassword]"
                          ></v-text-field>
                          <v-text-field
                            v-model="changePass.password"
                            :append-icon="password2 ? 'visibility_off' : 'visibility'"
                            :type="password2 ? 'text' : 'password'"
                            name="input-10-1"
                            label="Confirmar contraseña"
                            @click:append="password2 = !password2"
                            :rules="[rules.required,rules.validPassword]"
                          ></v-text-field>
                        </v-form>
                        <br>
                      </div>
                      <v-divider></v-divider>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <transition name="fade">
                          <v-btn
                            v-if="stateMachine()"
                            v-on:click="updateAccounts()"
                            color="primary"
                          >GUARDAR</v-btn>
                        </transition>
                      </v-card-actions>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
          </v-container>
          <v-layout row justify-center>
            <!-- <v-btn color="primary" dark @click="confirm = true">Open Dialog</v-btn> -->
            <v-dialog v-model="confirm" persistent max-width="290">
              <v-card>
                <v-card-title class="headline">Ha realizado cambios en su perfil</v-card-title>
                <v-card-text>¿Desea guardar los cambios?</v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="accent" flat @click="updateAccountsConfirm()">Guardar</v-btn>
                  <v-btn color="red" flat @click=" closeAll()">Salir</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-layout>
        </vue-perfect-scrollbar>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import Vue from "vue";
import AccountsServices from "@/services/AccountsServices";
import { mapGetters } from "vuex";
import { parse, format } from "path";
import moment, { locale } from "moment";
import { EventBus } from "@/imports/EventBus";

export default {
  computed: {
    ...mapGetters([      
      "catalogsProvince",
      "catalogsCanton",
      "catalogsCity",
      "catalogsCivilStatus",
      "catalogsGender",
      "catalogsNacionalities",
      "controlWatch",
      "userProfile",
      "userScopes"
    ])
  },
  mounted() {    
    if (this.userProfile != null) {      
      this.$nextTick(() => {          
        if (/* !this.userScopes.includes("aps_admin")&& */this.userScopes.length>0) {           
          setTimeout(() => {
            var date = this.userProfile.birth_date.split(" ");
            let year = date[0].split("/");
            if(this.userProfile.birth_date==""){
                    this.userProfile.birth_date = new Date().toISOString().substr(0, 10);
            }else if (parseInt(year) < 1950) {
                    this.userProfile.birth_date = "";
            }else {
              this.userProfile.birth_date = moment(
                this.userProfile.birth_date,
                "YYYY-MM-DD"
              ).format("YYYY-MM-DD");
            }
            this.$store.dispatch("getCatalogsProvince").then(() => {
              let resultSearch = this.catalogsProvince.find(
                obj => obj.code == this.userProfile.province
              );
              if(resultSearch){
              this.$store.dispatch(
                "getCatalogsCanton",
                resultSearch.provinceCode
              );
              this.$store.dispatch(
                "getCatalogsCityByProvince",
                resultSearch.provinceCode
              );
              }
              this.$store.dispatch("getCatalogsCivilStatus");
              this.$store.dispatch("getCatalogsGender");
              this.$store.dispatch("getCatalogsNationality");
            });
            this.existNewChanges = false;
            /* this.$store.dispatch("getCatalogsCanton"); */
            //this.gender[this.userProfile.gender] = true;
          }, 250);
        }
      });
    }
  },
  data() {
    return {
      birth_date: undefined,
      confirm: false,
      gender: {
        Masculino: false,
        Femenino: false,
        undefined: false
      },
      existNewChanges: false,
      menu: false,
      fullName: "",
      showFullName: true,
      disableInformation: false,
      dialog: false,
      notifications: false,
      sound: true,
      widgets: false,
      rol: [
        { text: "Admin", callback: () => "" },
        { text: "Editor", callback: () => "" },
        { text: "Agente", callback: () => "" }
      ],
      passValidate: "",
      oldPassErrorText: "",
      newPassErrorText: "",
      validatePassErrorText: "",
      newPhoneError: false,
      newPhoneErrorText: "",
      newPhones: "",
      isValidNewPassword: false,
      oldPassError: false,
      newPassError: false,
      validatePassError: false,
      validNewPhone: false,
      changePass: { oldPassword: "", password: "" },
      file: "",
      showPreview: true,
      passwordValidate: "",
      newPassword: "",
      password: "",
      imageData: "https://iceland-photo-tours.com/fb-avatar/",
      FileName: "",
      index: -1,
      image: [],
      changePassword: false,
      password1: false,
      password2: false,
      passwordModel1: "",
      passwordModel2: "",
      res: "",
      validPhones: false,
      validPhoneForm: [true],
      rules: {
        required: value => !!value || "Campo Requerido",
        counter: value => value.length >= 2 || "Minimo 2 caracteres",
        identification: value =>
          value.length == 10 || "Diez digitos obligatorios",
        phoneNumber: value => value.length >= 10 || "Minimo 10 digitos",
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Direccion email invalida";
        },
        password: value =>
          value == this.passValidate || "las contraseña no coinciden",
        passwordMain: value =>
          value == this.changePass.password || "las contraseña no coinciden",
        passNoEquals: value =>
          value != this.changePass.oldPassword ||
          "la nueva contraseña no puede ser igual que la antigua",
        validPassword: value => {
          const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[()/$@$!%*?&_#'"<>=^.,:;-])([A-Za-z\d/()$@$!%*?&_#'"<>=^.,:;-]|[^ ]){8,15}$/;
          return (
            pattern.test(value) ||
            "La contraseña debe tener como mínimo 8 caracteres e incluir mayúsculas, números y caracteres especiales"
          );
        }
      },
      existNewChanges: false
    };
  },
 
  methods: {
    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      this.userProfile.birth_date = [year, month, day].join("-");
      //console.log([year, month, day].join('-'))
      return [year, month, day].join("-");
    },
    customFilter(item, queryText, itemText) {
      const textOne = item.value.toLowerCase();
      const textTwo = item.code.toLowerCase();
      const searchText = queryText.toLowerCase();
      return (
        textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1
      );
    },
    changeProvince() {
      let resultSearch = this.catalogsProvince.find(
        obj => obj.code == this.userProfile.province
      );
      //console.log(resultSearch.provinceCode)
      this.$store.dispatch("getCatalogsCanton", resultSearch.provinceCode);
      this.$store.dispatch(
        "getCatalogsCityByProvince",
        resultSearch.provinceCode
      );
    },
    changeGender(value) {
      this.gender.Masculino = false;
      this.gender.Femenino = false;
      this.gender.undefined = false;
      this.gender[value] = true;
      this.userProfile.gender = value;
      this.existNewChanges = true;
    },
    saveDate(date) {
      this.$refs.menu.save(date);
    },
    saveDate1(date) {
      this.$refs.menu.save(date);
    },
    checkAPS() {
      if (this.userScopes.includes("APS")) {
        return true;
      } else {
        return false;
      }
    },
    checkAdmin() {
      if (this.userScopes.includes("ADMIN")) {
        return true;
      } else {
        return false;
      }
    },
    enableEdit() {
      this.showFullName = false;
      /*  this.disableInformation = false; */
    },
    close() {
      this.showFullName = true;
      this.dialog = false;
      this.changePassword = false;
      this.isValidNewPassword = false;
      this.validNewPhone = false;
      /*   this.disableInformation = true; */
      this.passValidate = "";
      this.changePass["oldPassword"] = "";
      this.changePass["password"] = "";
      this.newPhones = "";
      this.gender = {
        Masculino: false,
        Femenino: false,
        undefined: false
      };
      this.existNewChanges = false;
    },
    closeAll() {
      this.showFullName = true;
      this.dialog = false;
      this.confirm = false;
      this.changePassword = false;
      this.isValidNewPassword = false;
      this.validNewPhone = false;
      /*  this.disableInformation = true; */
      this.existNewChanges = false;
      this.passValidate = "";
      this.changePass["oldPassword"] = "";
      this.changePass["password"] = "";
      this.newPhones = "";
      this.dialog = false;
      this.confirm = false;
      this.gender = {
        Masculino: false,
        Femenino: false,
        undefined: false
      };
    },
    stateMachine() {
      var result = false;
      if (this.existNewChanges) {
        result = true;
      } /* 
      if (this.validNewPhone) {
        result = true;
      } */
      if (
        this.changePass.oldPassword != "" ||
        this.changePass.password != "" ||
        this.passValidate != ""
      ) {
        if (
          this.isValidNewPassword &&
          this.changePass.password == this.passValidate
        ) {
          result = true;
        } else {
          result = false;
        }
      }
      if (
        (this.changePass.oldPassword != "" ||
          this.changePass.password != "" ||
          this.passValidate != "") &&
        this.existNewChanges
      ) {
        if (
          this.isValidNewPassword &&
          this.changePass.password == this.passValidate
        ) {
          result = true;
        } else {
          result = false;
        }
      }
      return result;
    },
    async changeUserPassword(password) {
      if (this.changePass.password === this.passValidate) {
        var pass = this.passValidate;

        this.$root.$emit("showLoading", "Actualizando contraseña");

        try {
          const res = await this.$store.dispatch(
            "updatePasswordAccountIAM",
            this.changePass
          );

          if (res.data.code == 200) {

            try {
              await kafkaService.sendChangePassword(
                params.email,
                params.password
              );
              console.log("Kafka enviado");
            } catch (kafkaError) {
              console.error("Error Kafka:", kafkaError);
            }

            this.changeSiaerpPassword(pass);
            this.$root.$emit("showSnackBar", "Contraseña Cambiada", "accent");

            this.passValidate = "";
            this.changePass["oldPassword"] = "";
            this.changePass["password"] = "";
            this.$refs.formChangePass.reset();

          } else if (res.data.code == 401) {
            this.$root.$emit(
              "showSnackBar",
              "La contraseña actual no coincide",
              "error"
            );

            this.passValidate = "";
            this.changePass["oldPassword"] = "";
            this.changePass["password"] = "";
          }

        } catch (error) {
          console.error(error);
        }

        this.$root.$emit("hideLoading");

      } else {
        this.$root.$emit(
          "showSnackBar",
          "Las contraseñas no coinciden",
          "error"
        );
      }
    },
    changeSiaerpPassword(pass){
      var model = {
        Id : this.userProfile.user_id,
        identificacion : this.userProfile.identity,
        Password: pass

      }
      
      AccountsServices.updatePasswordSiaerp(model).then(res => {
        if (res.data.Error == 0) {
          this.$root.$emit("showSnackBar", "Contraseña Cambiada Siaerp", "accent");

        } else {
          this.$root.$emit(
          "showSnackBar",
          "No se actualizo en Siaerp",
          "error"
        );
        }
      })


    },
 
    uploadImage() {
      var doc = document.getElementById("profilePhoto");
      if (doc.files[0]) {
        let formData = new FormData();
        formData.append("file", doc.files[0], doc.files[0].name);

        this.$store.dispatch("uploadFile", formData).then(res => {
          this.userProfile.photoUrl = res.data.data.path;
          if (res.data.error !== 0) {
            this.$root.$emit(
              "showSnackBar",
              "Error al cargar archivo",
              "error"
            );
          } else {
            this.$root.$emit(
              "showSnackBar",
              "Carga de archivo exitosa",
              "accent"
            );
          }
        });
      } 
    },
    updateAccounts() {
      /* this.userProfile.agencies = ["LOJA", "SANTO DOMINGO"]; */
      this.$store.dispatch("updateAccount", this.userProfile).then(res => {
        if (res.data.code != 200) {
          this.$root.$emit(
            "showSnackBar",
            "Ocurrio un error al actualizar pefil",
            "error"
          );
        } else {
          if (
            this.isValidNewPassword &&
            this.changePass.password == this.passValidate
          ) {
            this.changeUserPassword();
          }
          this.$root.$emit("showSnackBar", "Perfil Editado");
          if (this.userProfile.first_name != "") {
            this.fullName =
              this.userProfile.first_name +
              " " +
              this.userProfile.second_name +
              " " +
              this.userProfile.first_surname +
              " " +
              this.userProfile.second_surname;
          }
          this.showFullName = false;
          this.existNewChanges = false;
          this.$refs.formChangePass.reset();
          this.changePass.oldPassword = "";
          this.changePass.password = "";
          this.passValidate = "";
        }
      });
      this.$root.$emit("hideLoading");
    },
    updateAccountsConfirm() {
      /* this.userProfile.agencies = ["LOJA", "SANTO DOMINGO"]; */
      this.$store.dispatch("updateAccount", this.userProfile).then(res => {
        if (res.data.code != 200) {
          this.$root.$emit(
            "showSnackBar",
            "Ocurrio un error al actualizar pefil",
            "error"
          );
        } else {
          if (
            this.isValidNewPassword &&
            this.changePass.password == this.passValidate
          ) {
            this.changeUserPassword();
          }
          this.$root.$emit("showSnackBar", "Perfil Editado");
          if (this.userProfile.first_name != "") {
            this.fullName =
              this.userProfile.first_name +
              " " +
              this.userProfile.second_name +
              " " +
              this.userProfile.first_surname +
              " " +
              this.userProfile.second_surname;
          }
          this.showFullName = false;
          this.existNewChanges = false;
          this.$refs.formChangePass.reset();
          this.changePass.oldPassword = "";
          this.changePass.password = "";
          this.passValidate = "";
          this.confirm = false;
          this.close();
        }
      });
      this.$root.$emit("hideLoading");
    },
    ispassword() {
      var result;
      if (
        this.password === this.passwordValidate &&
        (this.password != "" && this.passwordValidate != "")
      ) {
        result = true;
      } else {
        result = false;
      }
      return result;
    },
    handleFileUpload() {
      try {
        this.$root.$emit("showLoading", "Subiendo foto de perfil");
        this.file = this.$refs.profilePhoto.files[0];
        let formData = new FormData();
        formData.append("file", this.file, this.file.name);
        this.$store.dispatch("uploadFile", formData).then(res => {
          this.userProfile.photoUrl = res.data.data.path;
          this.$root.$emit("hideLoading");
          this.updateAccounts();
        });
      } catch (error) {
        this.$root.$emit("hideLoading");
      }
    },
    show() {
            try {
              if (/* !this.userScopes.includes("aps_admin")&& */this.userScopes.length>0) {
                this.$store.dispatch("getCatalogsProvince").then(() => {
                  let resultSearch = this.catalogsProvince.find(
                    obj => obj.code == this.userProfile.province
                  );
                  if(resultSearch){
                  this.$store.dispatch(
                    "getCatalogsCanton",
                    resultSearch.provinceCode
                  );
                  this.$store.dispatch(
                    "getCatalogsCityByProvince",
                    resultSearch.provinceCode
                  );
                  }
                  this.$store.dispatch("getCatalogsCivilStatus");
                  this.$store.dispatch("getCatalogsGender");
                  this.$store.dispatch("getCatalogsNationality");
                  this.gender[this.userProfile.gender] = true;
                  var date = this.userProfile.birth_date.split(" ");
                  let year = date[0].split("/");
                  if(this.userProfile.birth_date==""){
                    this.userProfile.birth_date = "";
                  }else if (parseInt(year) < 1950) {
                    this.userProfile.birth_date = new Date().toISOString().substr(0, 10);
                  } else {
                    this.userProfile.birth_date = moment(
                      this.userProfile.birth_date,
                      "YYYY-MM-DD"
                    ).format("YYYY-MM-DD");
                  }
                  this.existNewChanges = false;
                });
              }
            } catch (error) {}
            this.dialog = true;
    
    },
    addPhone() {
      if (this.validPhoneForm[this.validPhoneForm.length - 1]) {
        this.userProfile.phones.push("");
      }
    },
    removePhone(phone) {
      var index = this.userProfile.phones.indexOf(phone);
      this.userProfile.phones.splice(index, 1);
    }
  },
  watch: {
    userProfile: {
      handler(val) {
        this.existNewChanges = true;
        
      },
      deep: true
    }
  }
};
</script>
<style scoped>
.image-preview {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  padding: 20px;
}
img.preview {
  width: 200px;
  height: 200px;
  background-color: white;
  border: 1px solid #ddd;
  padding: 5px;
}
.inputfile {
  width: 0.1px !important;
  height: 0.1px !important;
  opacity: 0 !important;
  overflow: hidden !important;
  position: absolute !important;
  z-index: -1 !important ;
  background-color: red;
}

.pinta {
  border-style: solid;
  border-color: red;
  border-width: 3px;
}
.vertical-aling {
  display: table-cell !important ;
  vertical-align: middle !important;
}

@media screen and (max-width: 992px) {
  img.preview {
    width: 200px;
    height: 200px;
  }
}
/* On screens that are 600px or less, set the background color to olive */
@media screen and (max-width: 600px) {
  img.preview {
    width: 100px;
    height: 100px;
  }
}
</style>
